import {
  BANNER_DATA,
  ADVANTAGES_EFFECT,
  FEATURES,
  SCENARIO_EFFECT,
  ARCHITECTURE,
  DEMO_LIST,
  GALLERY,
} from '../../utils/const/products/big-screen';

import styles from '../../styles/common.module.scss';
import DetailBanner from '../../components/commonComponents/detailBanner';
import Introduction from '../../components/productPageComponents/introduction';
import Scenarios from '../../components/productPageComponents/scenario';
import Architecture from '../../components/commonComponents/architecture';
import Advantage from '../../components/commonComponents/featureCard';
import router from 'next/router';
import DemoPresentation from '../../components/productPageComponents/demoPresentation';
import Gallery from '../../components/productPageComponents/gallery';

/**
 *
 * @description 点播云详情页面
 */
const BigScreen = () => {
  return (
    <div className={styles.wrapper}>
      <DetailBanner
        bannerData={BANNER_DATA}
        onTry={() => router.push('/form/consult/try-big-screen')}
      />
      <Architecture data={ARCHITECTURE} bgColor="#ffffff" />
      <Introduction cards={FEATURES} initialOpen={true} bgColor="#f8f9fa" />
      {/* <DemoPresentation demoList={DEMO_LIST} type="big-screen" /> */}
      <Advantage advantages={ADVANTAGES_EFFECT} />
      <Scenarios scenarios={SCENARIO_EFFECT} bgColor="#f8f9fa" />
      <Gallery data={GALLERY} />
    </div>
  );
};

export default BigScreen;
